
import JSZip from 'jszip';
import { exportFile } from 'quasar';
import AdsApi from '../libs/ads-request/ads-api';

export default {
  name: 'InvoicesComponent',
  data: () => ({
    invoices: [],
    invoice: {},
    order_id: null,
  }),
  computed: {
    mobile() {
      return this.$q.screen.lt.md;
    },
    iconDownload() {
      const icon = {
        name: 'download',
        size: '',
      };

      if (this.$session.get('brand') === 'volkswagen') {
        icon.size = '20px';
      }

      return icon;
    },
  },
  mounted() {
    this.getInvoices();
  },
  methods: {
    downloadZip(invoice) {
      this.loaderShow('Descargando archivos');

      this.invoice = invoice;

      AdsApi.getInvoiceParams(this.invoice.orderId)
        .then((response) => {
          const { data } = response;

          const zip = new JSZip();

          zip.file(`FACTURA${this.invoice.orderId}.pdf`, data.pdfFile, {
            base64: true,
          });

          zip.file(`FACTURA${this.invoice.orderId}.xml`, data.xmlFile, {
            base64: true,
          });

          zip.generateAsync({ type: 'blob' }).then((content) => {
            exportFile(`FACTURA${this.invoice.orderId}.zip`, content, 'application/zip');
          });

          this.isDownload = false;
        })
        .catch((err) => this.alertShow(err, 'error'))
        .then(this.loaderHide);
    },
    getPreinvoice() {
      return AdsApi.getPreinvoice()
        .then((data) => {
          this.preInvoiceTotal = data.services[0].total;
          this.preInvoiceSubtotal = data.services[0].subtotal;
          this.taxesAmountPreinvoice = data.services[0].taxesAmount;
        })
        .catch((error) => {
          throw error;
        });
    },
    getInvoices() {
      this.loaderShow('Obteniendo facturas');
      const orders = this.$session.get('orders');
      if (orders.length > 0) {
        orders.forEach((order) => {
          if (order.orderType !== 'Garantía') {
            this.order_id = order.orderId;
            AdsApi.getInvoiceParams(order.orderIdDMS).then((response) => {
              const { data } = response;
              this.invoices.push({
                orderId: order.orderIdDMS,
                data,
              });
            });
          }
        });
      }
      this.loaderHide();
    },
  },
};
